import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { HttpServiceBase } from '../classes/HttpServiceBase';

export interface AccountPayload {
    email: string;
    name?: string;
    mobile?: string;
    /** Only sent when the user wants to change it; hashed server-side. */
    password?: string;
    passwordConfirm?: string;
}

/**
 * The logged-in user's own account details (backend rest/fyes/account).
 * The id is taken from the session token server-side — never sent by the client.
 */
@Injectable({ providedIn: 'root' })
export class AccountService extends HttpServiceBase {
    protected override baseUrl = '/account';

    constructor(private http: HttpClient) {
        super();
        this.assign(this);
    }

    /** GET /account -> the logged-in user's details. */
    public get(): Observable<any> {
        return this._http.get(this.baseUrl)
            .pipe(map((r: any) => r), catchError(this.handleError.bind(this)));
    }

    /** PUT /account -> update the logged-in user's details. */
    public update(payload: AccountPayload): Observable<any> {
        return this._http.put(this.baseUrl, payload)
            .pipe(map((r: any) => r), catchError(this.handleError.bind(this)));
    }

    /**
     * PUT /account/password -> change only the password. Works for both account
     * types: local accounts are updated in our DB, cloud gateway customers are
     * proxied to the FYES cloud.
     */
    public changePassword(password: string, passwordConfirm: string): Observable<any> {
        return this._http.put(this.baseUrl + '/password', { password, passwordConfirm })
            .pipe(map((r: any) => r), catchError(this.handleError.bind(this)));
    }
}
